import React from 'react';
import { Link } from 'react-router-dom';
import { TAREAS } from '../data/catalogo';
import { evento } from '../lib/medicion';

// La entrada al catálogo dentro de la banda de Tareas y de Agentes (An, 05/11): tres portadas de tareas, la del medio
// con su video andando (mudo, en loop; quieta con movimiento reducido), una explicación corta y el botón a /catalogo.
// Las portadas del preview son `<tarea>-vista.jpg`: un cuadro del segundo 9 del video, con la interfaz de la tarea a la
// vista (las `.jpg` son el gancho sobre negro y, detrás de la del medio, se veían como bloques negros).
const quieto = () => typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

const CatalogoEntrada = ({ tareas, titulo, texto, origen }) => {
  const [izq, medio, der] = tareas;
  return (
    <Link to="/catalogo" className="gh-entrada" onClick={() => evento('respuesta', { pantalla: 'ir_catalogo', opcion: `banda-${origen}` })}>
      <div className="gh-entrada__portadas" aria-hidden="true">
        <img src={`/catalogo/${izq}-vista.jpg`} alt="" loading="lazy" />
        {quieto()
          ? <img className="is-medio" src={`/catalogo/${medio}-vista.jpg`} alt="" loading="lazy" />
          : <video className="is-medio" src={`/catalogo/${medio}.mp4`} poster={`/catalogo/${medio}.jpg`} autoPlay muted loop playsInline preload="metadata" />}
        <img src={`/catalogo/${der}-vista.jpg`} alt="" loading="lazy" />
      </div>
      <div className="gh-entrada__texto">
        <b className="gh-entrada__titulo">{titulo}</b>
        <span>{texto}</span>
        <span className="gh-entrada__tareas">{tareas.map(k => TAREAS[k].nombre).join(' · ')} y más</span>
        <span className="guia-btn guia-btn--solido gh-entrada__boton">Ver las tareas</span>
      </div>
    </Link>
  );
};

export default CatalogoEntrada;
